<div class="home-component" *transloco="let t">
  <div class="home-header">
    <img
      class="logo"
      src="../../../../assets/Curamenta_Logo.svg"
      alt="Curamenta Logo"
      width="375"
      height="343"
    />
  </div>
  <div class="home-content">
    <img
      class="logo"
      src="../../../assets/error.svg"
      alt=""
      width="375"
      height="343"
    />
    <h1 class="headline">{{ 'app.errors.error' | transloco }}</h1>
    <p class="text-large">{{ 'app.errors.retry' | transloco }}</p>
    <br />
    <p class="text-large">{{ 'app.errors.callSupport' | transloco }}</p>
    <div class="home-footer">
      <xt-portal-button
        width="large"
        [text]="t('app.header.buttons.logout')"
        (clickEvent)="onLogout()"
      ></xt-portal-button>
    </div>
  </div>
</div>
